import React from "react";
import background from "../assets/background.png";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex justify-center items-center"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <button
        type="submit"
        className="bg-[#3f56cf] text-white text-center w-1/4 p-2 rounded-lg mr-1 "
        onClick={() => navigate("/signup")}
      >
        Request for Access
      </button>
      <button
        type="submit"
        className="bg-[#3f56cf] text-white text-center w-1/4 p-2 rounded-lg ml-1"
        onClick={() => navigate("/login")}
      >
        Login
      </button>
    </div>
  );
};

export default Home;
